"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _TimelineFilterOptions = _interopRequireDefault(require("crm_ui/timeline/helpers/TimelineFilterOptions"));

var _UICheckbox = _interopRequireDefault(require("UIComponents/input/UICheckbox"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _FormattedHTMLMessage = _interopRequireDefault(require("I18n/components/FormattedHTMLMessage"));

var _PureComponent2 = _interopRequireDefault(require("customer-data-ui-utilities/component/PureComponent"));

var _UIList = _interopRequireDefault(require("UIComponents/list/UIList"));

var _ObjectTypesType = _interopRequireDefault(require("customer-data-objects-ui-components/propTypes/ObjectTypesType"));

var _ObjectTypes = require("customer-data-objects/constants/ObjectTypes");

var _ComponentMethods = require("customer-data-ui-utilities/component/ComponentMethods");

var _immutable = require("immutable");

var _reactImmutableProptypes = _interopRequireDefault(require("react-immutable-proptypes"));

function getEventTypeAndLabel(eventType, objectType) {
  var label;
  var message;

  if (eventType.has && eventType.has('name')) {
    label = eventType.get('name');
    eventType = eventType.get('id');
  } else {
    message = _TimelineFilterOptions.default.TYPE_LABEL_MAP[eventType];

    if (eventType === 'STAGES' && objectType === _ObjectTypes.TICKET) {
      message = _TimelineFilterOptions.default.TYPE_LABEL_MAP.TICKET_STAGES;
    }

    if (!message) {
      // eslint-disable-next-line no-console
      console.error("no translation for " + eventType);
    }

    label = _react.default.createElement(_FormattedHTMLMessage.default, {
      message: message
    });
  }

  return {
    label: label,
    eventType: eventType
  };
}

var TimelineFilterList =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(TimelineFilterList, _PureComponent);

  function TimelineFilterList() {
    var _this;

    (0, _classCallCheck2.default)(this, TimelineFilterList);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(TimelineFilterList).call(this));
    (0, _ComponentMethods.bindHandlers)((0, _assertThisInitialized2.default)(_this));
    _this.partial = (0, _ComponentMethods.makePartial)();
    return _this;
  }

  (0, _createClass2.default)(TimelineFilterList, [{
    key: "handleRenderCheckbox",
    value: function handleRenderCheckbox(etype) {
      var objectType = this.props.objectType;
      var favoriteEvents = this.props.timelineFavoriteEvents;

      var _getEventTypeAndLabel = getEventTypeAndLabel(etype, objectType),
          label = _getEventTypeAndLabel.label,
          eventType = _getEventTypeAndLabel.eventType;

      var checked = favoriteEvents.includes(eventType);
      return _react.default.createElement(_UICheckbox.default, {
        key: eventType,
        checked: checked,
        onChange: this.partial(this.props.handleFilterChange, eventType),
        "data-selenium-test": "timeline-filter-checkbox-" + eventType,
        "data-selenium-checked": checked
      }, _react.default.createElement("span", {
        className: "p-left-3 white-space-nowrap"
      }, label));
    }
  }, {
    key: "render",
    value: function render() {
      return _react.default.createElement(_UIList.default, {
        className: this.props.className
      }, this.props.filters.toArray().map(this.handleRenderCheckbox));
    }
  }]);
  return TimelineFilterList;
}(_PureComponent2.default);

TimelineFilterList.propTypes = {
  className: _propTypes.default.string,
  filters: _propTypes.default.instanceOf(_immutable.List).isRequired,
  handleFilterChange: _propTypes.default.func.isRequired,
  objectType: _ObjectTypesType.default.isRequired,
  timelineFavoriteEvents: _reactImmutableProptypes.default.list
};
var _default = TimelineFilterList;
exports.default = _default;
module.exports = exports.default;